// material-ui
import { Box, Typography } from '@mui/material';

// project import
import NavGroup from './NavGroup';
import { menuItems } from '../../../../../routes/MainRoutes'

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
  const navGroups = menuItems.map((item, key) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={key} item={item} />;
      default:
        return (
          <Typography key={key} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
};

export default Navigation;
